"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _Link = require("./Link.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Basic Link component, intended for external links
 */
// intentionally left as a functional component
var Link = function Link(_ref) {
  var aRel = _ref.aRel,
      aTarget = _ref.aTarget,
      className = _ref.className,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      isBlock = _ref.isBlock,
      overDark = _ref.overDark,
      url = _ref.url,
      props = _objectWithoutProperties(_ref, ["aRel", "aTarget", "className", "children", "dataTestId", "disabled", "isBlock", "overDark", "url"]);

  return /*#__PURE__*/_react.default.createElement(_Link.StyledLink, _extends({
    className: className,
    "data-test-id": dataTestId,
    disabled: disabled,
    href: disabled ? undefined : url,
    isBlock: isBlock,
    overDark: overDark,
    rel: aTarget ? aRel || 'noopener noreferrer' : aRel || null,
    target: aTarget
  }, props), children);
};

Link.propTypes = {
  /** html rel value for the link (defaults to 'noopener noreferrer' when aTarget is provided)
   * <br />https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a
   * <br />https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types
   */
  aRel: _propTypes.default.string,

  /** target attribute use for opening in new tab, etc */
  aTarget: _propTypes.default.oneOf(['_self', '_blank', '_parent', '_top']),

  /** Any nodes that are valid children of an 'a' tag */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Hook for disabling the component */
  disabled: _propTypes.default.bool,

  /** Flag for displaying the element as inline-block (so that you can set width if ever desired, and will respect top and bottom margins) */
  isBlock: _propTypes.default.bool,

  /** Styling flag for displaying over a dark background */
  overDark: _propTypes.default.bool,

  /** URL for the link */
  url: _propTypes.default.string
};
Link.defaultProps = {
  aRel: null,
  aTarget: null,
  children: undefined,
  className: '',
  disabled: false,
  isBlock: false,
  overDark: false,
  url: null
};
var _default = Link;
exports.default = _default;